import React from "react"
import ReactDom from "react-dom"
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Link,
  withRouter,
  Switch
} from "react-router-dom"
import { Provider, connect } from "react-redux"
import {
  GearIcon,
  CrownIcon,
  HomeIcon,
  TripIcon,
  ReportIcon,
  CoinIcon,
  VehicleIcon,
  DoorIcon,
  RefundIcon,
  TripsIcon,
  MarkerIcon,
  DeliveryIcon,
  BankCardIcon,
  BriefcaseIcon,
  UserIcon,
  TrackerIcon,
  MergeIcon,
  ReturnOnInvestmentIcon
} from "../../core/icons"
import "./Menu.css"
import { logout } from "../../user/actions"
import { push } from "react-router-redux"
import { Icon } from "antd"

// https://reacttraining.com/react-router/web/example/custom-link
const IconLink = ({
  label,
  to,
  activeOnlyWhenExact,
  icon: Icon,
  activeColor = "#31B59F"
}) => (
  <Route
    path={to}
    exact={activeOnlyWhenExact}
    children={({ match }) => (
      <div className={match ? "active" : ""}>
        <Link to={to}>
          {match ? <Icon color={activeColor} /> : <Icon />}
          <span>{label}</span>
        </Link>
      </div>
    )}
  />
)

const Menu = ({ dispatch, forceDisplay }) => (
  <div className="Menu" style={forceDisplay ? { display: "block" } : null}>
    <a
      onClick={() => {
        dispatch(push(`/dashboard`))
      }}
    >
      <Icon style={{ fontWeight: "600", color: "#31b59f" }} type="left" />
      <span style={{ fontWeight: "600", color: "#31b59f" }}> DASHBOARD</span>
    </a>
    <hr />
    <h2>Account</h2>
    <IconLink
      to={`/account/profile`}
      label="Profile Settings"
      icon={UserIcon}
    />
    <IconLink
      to={`/account/business-lines`}
      label="Business Lines"
      icon={BriefcaseIcon}
    />
    <IconLink to={`/account/tax-center`} label="Tax Center" icon={RefundIcon} />
    <IconLink
      to={`/account/data-exports`}
      label="Data Exports"
      icon={ReportIcon}
    />
    <IconLink
      to={`/account/integrations`}
      label="Integrations"
      icon={MergeIcon}
    />
    <br />
    <h2>Transactions</h2>
    <IconLink
      to={`/account/bank-card`}
      label="Banks & Cards"
      icon={BankCardIcon}
    />
    <IconLink
      to={`/account/favorite-transactions`}
      label="Rules"
      icon={ReturnOnInvestmentIcon}
    />

    <h2>Trips</h2>
    <IconLink
      to={`/account/tracker`}
      label="Tracker Settings"
      icon={TrackerIcon}
    />
    <IconLink
      to={`/account/favorite-trips`}
      label="Favorite Trips"
      icon={TripsIcon}
    />
    <IconLink
      to={`/account/favorite-places`}
      label="Favorite Places"
      icon={MarkerIcon}
    />
    <IconLink to={`/account/vehicles`} label="Vehicles" icon={VehicleIcon} />
    <IconLink
      to={`/account/work-hours`}
      label="Work Hours"
      icon={DeliveryIcon}
    />
    <hr />
    <div>
      <a onClick={() => dispatch(logout())}>
        <DoorIcon />
        <span>Sign out</span>
      </a>
    </div>
  </div>
)

export default connect()(Menu)



// WEBPACK FOOTER //
// ./src/account/menu/Menu.js